export default __webpack_public_path__ + "static/media/controls_touch_3.f8d53103.svg";